import { Component, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ToggleOption } from '../primitives.types';

/**
 * Design-system toggle group — wraps mat-button-toggle-group as a primitive.
 *
 * Usage:
 *   <kt-button-toggle-group
 *     [options]="[{value: 'a', label: 'Option A'}, {value: 'b', label: 'Option B'}]"
 *     [(ngModel)]="selectedValue">
 *   </kt-button-toggle-group>
 *
 *   Or with icons:
 *   <kt-button-toggle-group
 *     [options]="[{value: 'asset', label: 'Asset level', icon: 'devices'}, {value: 'fleet', label: 'Fleet level', icon: 'category'}]"
 *     [(ngModel)]="activeTab"
 *     size="sm">
 *   </kt-button-toggle-group>
 */
@Component({
  selector: 'kt-button-toggle-group',
  templateUrl: './button-toggle-group.component.html',
  styleUrls: ['./button-toggle-group.component.scss'],
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => ButtonToggleGroupComponent), multi: true }]
})
export class ButtonToggleGroupComponent implements ControlValueAccessor {
  /** Two or more toggle options. */
  @Input() options: ToggleOption[] = [];
  /** Size variant — 'sm' (28px), 'md' (36px, default), 'lg' (40px). */
  @Input() size: 'sm' | 'md' | 'lg' = 'md';
  /** Disabled state for the whole group. */
  @Input() disabled = false;

  value: any = null;

  onChange = (_: any) => { };
  onTouched = () => { };

  onGroupChange(value: any) {
    this.value = value;
    this.onChange(this.value);
    this.onTouched();
  }

  writeValue(value: any) { this.value = value; }
  registerOnChange(fn: any) { this.onChange = fn; }
  registerOnTouched(fn: any) { this.onTouched = fn; }
  setDisabledState(isDisabled: boolean) { this.disabled = isDisabled; }
}
